export default {
  RECEIVED: 'R',
  SENT: 'S'
}
